import React, { useRef, useState } from "react";
import styled from "styled-components";
import { GoPlus } from "react-icons/go";
import colors from "../../../theme/color/ColorTheme";
import fontSize from "../../../theme/fonts/FontTheme";

const Wrapper = styled.div`
  max-width: 600px;
  margin: 50px auto;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const Heading = styled.h1`
  font-weight: 400;
  font-size: ${fontSize.s};
  letter-spacing: 0.12em;
  display: inline-block;
  text-transform: uppercase;
  color: ${colors.maroon};
`;

const Accordion = styled.div`
  display: flex;
  flex-direction: column;
  border-top: 1px solid ${colors.line};
`;

const IconWrapper = styled.div`
  svg {
    height: 18px;
    width: 18px;
    color: ${colors.black};
    transition: color 0.3s ease, transform 0.3s ease;
    transform: ${({ isOpen }) => (isOpen ? "rotate(90deg)" : "rotate(0deg)")};
  }
`;

const ToggleCard = styled.div`
  padding: 8px 0;
  cursor: pointer;
  border-bottom: 1px solid ${colors.line};
`;

const CardHeader = styled.div`
  display: flex;
  padding: 8px 4px;
  align-items: center;
  justify-content: space-between;

  span {
    letter-spacing: 0.1rem;
    font-size: ${fontSize.xxs};
    text-transform: uppercase;
  }
`;

const CardBody = styled.div`
  margin: 0px 4px;
  overflow: hidden;
  max-height: ${({ maxHeight }) => `${maxHeight}px`};
  transition: max-height 0.5s cubic-bezier(0.4, 0, 0.2, 1);
`;

const Description = styled.p`
  letter-spacing: 0.04rem;
  line-height: 1.24rem;
  color: ${colors.black};
  font-size: ${fontSize.xxs};
`;

/* ---------------- FAQ Data ---------------- */

const FAQ_DATA = {
  shipping: [
    {
      header: "International Shipping",
      description: `Norlha ships to the shipping address provided by the customer...Norlha ships to the shipping address provided by the customer...Norlha ships to the shipping address provided by the customer...Norlha ships to the shipping address provided by the customer...Norlha ships to the shipping address provided by the customer...Norlha ships to the shipping address provided by the customer...Norlha ships to the shipping address provided by the customer...`,
    },
    {
      header: "Delivery Time",
      description: `Orders typically take 7-14 business days...`,
    },
  ],
  returns: [
    {
      header: "Composition & Care",
      description: `This long jumpsuit, crafted in France from Italian satin crêpe...`,
    },
    {
      header: "Garment Journey",
      description: `Every piece is hand-crafted with care from high-quality materials...`,
    },
  ],
  privacy: [
    {
      header: "Privacy Policy",
      description: `We respect your privacy and will never share your information...`,
    },
  ],
  careGuide: [
    {
      header: "Care Instructions",
      description: `Hand wash cold, do not bleach, lay flat to dry...`,
    },
  ],
};

function FaqSection({ type }) {
  const [openIndex, setOpenIndex] = useState(null);
  const [heights, setHeights] = useState([]);
  const cardRefs = useRef([]);

  const toggleCard = (index) => {
    if (cardRefs.current[index]) {
      const newHeights = [...heights];
      newHeights[index] = cardRefs.current[index].scrollHeight;
      setHeights(newHeights);
    }
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqItems = FAQ_DATA[type] || [];

  return (
    <Wrapper>
      <Container>
        <Heading>{type.toUpperCase()}</Heading>
        <Accordion>
          {faqItems.map((item, index) => (
            <ToggleCard key={index}>
              <CardHeader onClick={() => toggleCard(index)}>
                <span>{item.header}</span>
                <IconWrapper isOpen={openIndex === index}>
                  <GoPlus />
                </IconWrapper>
              </CardHeader>
              <CardBody
                maxHeight={openIndex === index ? heights[index] || 0 : 0}
              >
                <Description ref={(el) => (cardRefs.current[index] = el)}>
                  {item.description}
                </Description>
              </CardBody>
            </ToggleCard>
          ))}
        </Accordion>
      </Container>
    </Wrapper>
  );
}

export default FaqSection;
